'use client'

import React from 'react'
import Link from 'next/link'
import { Trans, useTranslation } from 'react-i18next'
import { Faq, type FaqItem } from '../../components/site/faq'
import { Reveal } from '../../components/site/reveal'
import { SectionHead } from '../../components/site/section-head'
import { SiteSection } from '../../components/site/section'
import { trackSiteLinkClicked } from '@/lib/analytics'

/**
 * 八題。題目與答案在 i18n 是扁平的 qN／aN（第二段是 aNb）而不是一個陣列：
 * en ↔ zh-TW 的 key parity 測試把陣列當成單一個 leaf，少翻一段不會被擋下來。
 */
const QUESTIONS: Array<{ question: string; answers: string[] }> = [
  { question: 'q1', answers: ['a1'] },
  { question: 'q2', answers: ['a2'] },
  { question: 'q3', answers: ['a3'] },
  { question: 'q4', answers: ['a4'] },
  { question: 'q5', answers: ['a5', 'a5b'] },
  { question: 'q6', answers: ['a6', 'a6b'] },
  { question: 'q7', answers: ['a7', 'a7b'] },
  { question: 'q8', answers: ['a8'] },
]

export function DictationFaqSection() {
  const { t } = useTranslation(['web'])

  const items: FaqItem[] = QUESTIONS.map(({ question, answers }) => ({
    key: question,
    question: t(`web:dictationPage.faq.${question}`),
    answers: answers.map((answer) => (
      <Trans
        key={answer}
        t={t}
        i18nKey={`web:dictationPage.faq.${answer}`}
        components={{
          privacy: (
            <Link
              href="/privacy"
              onClick={() => trackSiteLinkClicked('faq', '/privacy')}
              className="border-b border-border text-foreground transition-colors hover:border-foreground"
            />
          ),
        }}
      />
    )),
  }))

  return (
    <SiteSection id="faq" trackingKey="faq">
      <Reveal>
        <SectionHead
          eyebrow={t('web:dictationPage.faq.eyebrow')}
          titleKey="web:dictationPage.faq.title"
        />
      </Reveal>
      <Reveal className="mt-(--gap-lg)">
        <Faq items={items} />
      </Reveal>
    </SiteSection>
  )
}
